import React from "react";

/**
 * 飞机SVG图标组件 (实心版)
 * Used in AircraftTag
 */
export const AirplaneIcon = ({ color, style = {} }) => (
    <svg
        viewBox="0 0 1024 1024"
        width="16px"
        height="16px"
        fill={color}
        style={{
            marginRight: "4px",
            position: "relative",
            top: "2px",
            ...style,
        }}
    >
        <path d="M918.4 420.8h-162.048L466.432 64h-133.76l133.76 356.8H193.28L79.04 330.24H0l67.328 268.992h399.104l-133.76 356.8h133.76l289.92-356.8h223.04c19.2 0 44.608 0 44.608-44.608 0-59.264-46.208-133.76-105.6-133.76z" />
    </svg>
);

/**
 * 飞机SVG图标组件 (描边版/Outlined)
 * 适配 Ant Design Outlined 风格
 * Used in SystemPortalWidget
 */
export const AirplaneOutlined = ({ style = {}, className, ...props }) => (
    <svg
        viewBox="-30 -30 1084 1084" // Tighter padding to increase visual size
        width="1em"
        height="1em"
        focusable="false"
        fill="none"
        stroke="currentColor"
        strokeWidth="80"
        strokeLinejoin="round"
        className={className}
        style={{
            verticalAlign: "-0.125em", // AntD default alignment
            ...style,
        }}
        {...props}
    >
        <path d="M918.4 420.8h-162.048L466.432 64h-133.76l133.76 356.8H193.28L79.04 330.24H0l67.328 268.992h399.104l-133.76 356.8h133.76l289.92-356.8h223.04c19.2 0 44.608 0 44.608-44.608 0-59.264-46.208-133.76-105.6-133.76z" />
    </svg>
);
